import React, { Component } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";

import Intro from "./Intro";
import Loading from "./Loading";
import Modal from "./Modal";
import About from "./About";
import locations from "./locations";
import Tooltip from "./tooltip";
import Rates from "./hover_rate";
import StarrySkyShader from "../StarrySkyShader";

class AA extends Component {
  camera = new THREE.PerspectiveCamera(
    45,
    window.innerWidth / window.innerHeight,
    1,
    4000
  );
  mouse = new THREE.Vector2();
  raycaster = new THREE.Raycaster();
  fire_locations = require("../../JSON/US_20200101_prediction_2.json");
  target = 0;

  onMouseMove(event, mouse, raycaster, camera, scene) {
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
    //fire_locations
    // normal tooltip
    // this.jQuery('tooltip').style.visibility = 'hidden';
    document.getElementById("tooltip").style.left =
      (event.clientX / window.innerWidth) * 100 + 2 + "%";
    document.getElementById("tooltip").style.top =
      (event.clientY / window.innerHeight) * 100 - 5 + "%";

    raycaster.setFromCamera(mouse, camera);
    var intersects = raycaster.intersectObjects(scene.children, true);
    var object = intersects.length ? intersects[0].object : null;

    if (
      document.getElementById("modal").style.display !== "none" ||
      document.getElementById("loading").style.display !== "none" ||
      document.getElementById("about").style.display !== "none" ||
      document.getElementById("intro").style.display !== "none"
    ) {
      object = null;
    }

    if (object !== null && object.name === "user") {
      object = intersects.length > 1 ? intersects[1].object : null;
      if (object !== null && object.name === "user") {
        this.jQuery("tooltip").innerHTML = "You're Here!!";
        this.jQuery("tooltip").style.visibility = "visible";
      }
      if (object !== null && object.name === "user") {
        object = intersects.length > 2 ? intersects[2].object : null;
        this.jQuery("tooltip").innerHTML = "You're Here!!";
        this.jQuery("tooltip").style.visibility = "visible";
      }
    }

    if (
      object !== null &&
      object.name !== "mesh_0" &&
      object.name !== "mesh_1" &&
      object.name !== "sky"
    ) {
      document.getElementsByTagName("body")[0].style.cursor = "pointer";
    } else {
      document.getElementsByTagName("body")[0].style.cursor = "default";
    }

    if (
      object !== null &&
      (object.name.includes("Cube0") || object.name.includes("balloon"))
    ) {
      this.jQuery("tooltip").innerHTML = "Loon";
      this.jQuery("tooltip").style.visibility = "visible";
    } else if (object !== null && object.name in this.fire_locations) {
      this.target = this.fire_locations[object.name].confidence;
      this.jQuery("tooltip").innerHTML = this.target + "%";
      this.jQuery("tooltip").style.visibility = "visible";
    } else if (intersects.length > 1 && intersects[1].object.name === "user") {
      this.jQuery("tooltip").innerHTML = "You're Here!!";
      this.jQuery("tooltip").style.visibility = "visible";
    } else if (
      (object !== null && object.name === "moon") ||
      (intersects.length > 0 && intersects[0].object.name === "moon") ||
      (intersects.length > 1 && intersects[1].object.name === "moon")
    ) {
      this.jQuery("tooltip").innerHTML = "To the moon!!!";
      this.jQuery("tooltip").style.visibility = "visible";
    } else if (object !== null && object.name === "tornado") {
      object = intersects.length > 2 ? intersects[2].object : null;
      this.jQuery("tooltip").innerHTML = "DO NOT CLICK ME - 10000% Wildfire";
      this.jQuery("tooltip").style.visibility = "visible";
    } else if (
      (object !== null && object.name === "sun") ||
      (intersects.length > 0 && intersects[0].object.name === "sun") ||
      (intersects.length > 1 && intersects[1].object.name === "sun")
    ) {
      this.jQuery("tooltip").innerHTML = "Too bright, Nothing to see here";
      this.jQuery("tooltip").style.visibility = "visible";
      // DEBUG
      // } else if(object!=null){
      // 	this.jQuery('tooltip').innerHTML = object.name;
      // 	this.jQuery('tooltip').style.visibility = 'visible';
    } else {
      this.jQuery("tooltip").innerHTML = "";
      this.jQuery("tooltip").style.visibility = "hidden";
    }
  }

  mouseClick(scene, raycaster, mouse, camera) {
    this.jQuery("tooltip").style.visibility = "hidden";
    if (document.getElementById("modal").style.display === "none") {
      	var balloon = scene.getObjectByName("balloon");
      	var tornado = scene.getObjectByName("tornado");
		var globe = scene.getObjectByName('earth')

      raycaster.setFromCamera(mouse, camera);
      var intersects = raycaster.intersectObjects(scene.children, true);

      var object = intersects.length ? intersects[0].object : null;

      if (object !== null && object.name === "user") {
        object = intersects.length > 1 ? intersects[1].object : null;
        if (object !== null && object.name === "user") {
          object = intersects.length > 2 ? intersects[2].object : null;
        }
      }

      if (
        object !== null &&
        (object.name.includes("Cube0") || object.name === "balloon")
      ) {
        // BALLOON ABOUT ME INFO
        this.jQuery("about").style.display = "flex";
      } else if (
        (object !== null && object.name === "moon") ||
        (intersects.length > 0 && intersects[0].object.name === "moon") ||
        (intersects.length > 1 && intersects[1].object.name === "moon")
      ) {
        var answer = window.confirm("Going to the Moon in a new tab???");
        if (answer) {
          window.open("https://hoangluu404.web.app/", "_blank");
        } else {
          //some code
        }
      } else if (object !== null && object.name in this.fire_locations) {
        var from = new THREE.Vector3(
          camera.position.x,
          camera.position.y,
          camera.position.z
        );
        var to = this.angles2xyz(
          this.fire_locations[object.name].latitude + 1,
          this.long2angles(this.fire_locations[object.name].longitude),
          250
        );

        new TWEEN.Tween({
          x: from.x,
          y: from.y,
          z: from.z,
        })
          .to({ x: to[0], y: to[1], z: to[2] }, 2000)
          .onUpdate(function (val) {
            camera.position.x = val.x;
            camera.position.y = val.y;
            camera.position.z = val.z;
          })
          .easing(TWEEN.Easing.Elastic.Out)
          .repeat()
          .start()
          .onComplete(() => {
            this.jQuery("name").innerHTML =
				this.fire_locations[object.name].confidence +
              	"% chance to get Wildfire at" +
				"<br/>" +
              	this.fire_locations[object.name].longitude + ' longitude, ' +
              	this.fire_locations[object.name].latitude + ' latitude';

            this.jQuery("modal").style.display = "flex";
          });

        from = new THREE.Vector3(
          balloon.position.x,
          balloon.position.y,
          balloon.position.z
        );
        to = this.angles2xyz(
          this.fire_locations[object.name].latitude + 1,
          this.long2angles(this.fire_locations[object.name].longitude),
          150
        );
        let max = 2;
        let min = max * -1;
        let randX = Math.random() * (max - min) + min;
        let randY = Math.random() * (max - min) + min;
        let randZ = Math.random() * (max - min) + min;
        new TWEEN.Tween({
          x: from.x,
          y: from.y,
          z: from.z,
        })
          .to({ x: to[0] + randX, y: to[1] + randY, z: to[2] + randZ }, 1000)
          .onUpdate(function (val) {
            balloon.position.x = val.x;
            balloon.position.y = val.y;
            balloon.position.z = val.z;
            balloon.lookAt(0, 50, 0);
          })
          .easing(TWEEN.Easing.Quartic.Out)
          .repeat()
          .start()
          .onComplete(() => {});

        new TWEEN.Tween({
          rot: 0,
        })
          .to({ rot: Math.PI }, 1000)
          .onUpdate(function (val) {
            balloon.rotation.y = val.rot;
          })
          .easing(TWEEN.Easing.Linear.None)
          .repeat()
          .start()
          .onComplete(() => {});
      } else if (object !== null && object.name == 'tornado'){
  
			
		  new TWEEN.Tween({
			rot: 0,
			scale: 0.005,
			x: tornado.position.x,
			y: tornado.position.y,
			z: tornado.position.z
		  })
			.to({ 
				rot: 50 * Math.PI,
				scale: 5,
				// x: pos[0],
				// y: pos[1],
				// z: pos[2]
				x: -2*balloon.position.x,
				y: -2*balloon.position.y,
				z: -2*balloon.position.z

			}, 3000)
			.onUpdate(function (val) {
			  tornado.rotation.y = val.rot;
			  globe.rotation.y = val.rot
			  tornado.position.x = val.x;
			  tornado.position.y = val.y;
			  tornado.position.z = val.z;
			
			  tornado.scale.set(val.scale, val.scale, val.scale)
			  globe.scale.set(val.scale/2, val.scale/2, val.scale/2)
			})
			.easing(TWEEN.Easing.Back.Out)
			.repeat()
			.start()
			.onComplete(() => {
				alert('You destroyed the world T.T')
				window.location.reload();
			});

		}
    }
  }

  jQuery(id) {
    return document.getElementById(id);
  }

  long2angles(long) {
    return long + 94;
  }

  angles2xyz(rotX, rotY, distance) {
    rotX = (rotX * Math.PI) / 180;
    rotY = ((rotY + 90) * Math.PI) / 180;
    let x = Math.cos(rotX) * Math.cos(rotY);
    let y = Math.cos(rotX) * Math.sin(rotY);
    let z = Math.sin(rotX);
    return [x * distance, z * distance, y * distance];
  }

  componentDidMount() {
    console.warn = () => {};
    console.error = () => {};
    document.getElementById("modal").style.display = "none";
    document.getElementById("loading").style.display = "block";
    document.getElementById("about").style.display = "none";

    let parent = this;
    this.camera.lookAt(new THREE.Vector3(0, 0, 0));

    var renderer = new THREE.WebGLRenderer();
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFShadowMap;
    renderer.shadowMap.autoUpdate = true;
    renderer.receiveShadow = true;
    document.body.appendChild(renderer.domElement);

    window.addEventListener(
      "resize",
      () => {
        _OnWindowResize(this.camera);
      },
      false
    );
    var _OnWindowResize = function (camera) {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
      document.getElementById("modal").style.height = window.height;
      document.getElementById("modal").style.width = window.width;
      document.getElementById("about").style.height = window.height;
      document.getElementById("about").style.width = window.width;
    };

    this.scene = new THREE.Scene();
    this.scene.fog = new THREE.Fog("#000005", 1, 3000);

    // SKY / GALAXY
    var skyDomeRadius = 700;
    var sphereMaterial = new THREE.ShaderMaterial({
      uniforms: {
        skyRadius: { value: skyDomeRadius },
        env_c1: { value: new THREE.Color("#0d1a2f") },
        env_c2: { value: new THREE.Color("#000") },
        noiseOffset: { value: new THREE.Vector3(100.01, 100.01, 100.01) },
        starSize: { value: 0.01 },
        starDensity: { value: 0.05 },
        clusterStrength: { value: 0.1 },
        clusterSize: { value: 0.2 },
      },
      vertexShader: StarrySkyShader.vertexShader,
      fragmentShader: StarrySkyShader.fragmentShader,
      side: THREE.BackSide,
    });
    var sphereGeometry = new THREE.SphereGeometry(skyDomeRadius, 20, 20);
    var skyDome = new THREE.Mesh(sphereGeometry, sphereMaterial);
    skyDome.name = "sky";
    this.scene.add(skyDome);

    // load Globe
    var loadGlobe = function async(scene) {
      const gltfLoader = new GLTFLoader(manager);
      gltfLoader.load("3D/earth/scene.gltf", (gltf) => {
        gltf.scene.traverse(function (node) {
          if (node.isMesh) {
            // node.castShadow = true;
            node.receiveShadow = true;
            let temp = node.material.color;
            node.material = new THREE.MeshStandardMaterial({
              color: temp,
              roughness: 0.6,
              metalness: 0.4,
              // emissive: 0xfff,
            });
          }
        });
        gltf.castShadow = true;
        gltf.scene.castShadow = true;
        const root = gltf.scene;
        root.name = "earth";
        root.receiveShadow = true;
        root.castShadow = true;
        root.eulerOrder = "ZYX";
        root.rotation.y = Math.PI;

        scene.add(root);
      });
    };
    loadGlobe(this.scene);

    // LOCATIONS has Name, rotation x and rotation y in DEG
    var distance_from_earth_core = 107;
    console.log("FILE: locations", locations);

    var manager = new THREE.LoadingManager();

    manager.onProgress = function (item, loaded, total) {
      //   console.log(item, loaded, total);
    };
    manager.onLoad = function () {
      console.log("all items loaded");
      document.getElementById("loading").style.display = "none";
    };
    manager.onError = function () {
      console.log("there has been an error");
    };

    // WILD FIRE MARKERS
    this.fire_locations = this.fire_locations.data;
    console.log(this.fire_locations);
    var fire_colors = ["#fff", "#e3ff05", "#ffa905", "#f01043", '#500'];
    // var fire_colors = ["#000", "#f00", "#0f0", "#00f", '#fff'];

    var geometry = new THREE.SphereGeometry(1.5, 20, 20);
    var material = new THREE.MeshToonMaterial({
      color: "#555",
    });

    var loadMarkers = function async(scene) {
      Object.keys(parent.fire_locations).forEach((index) => {
        var location = parent.fire_locations[index];
        const gltfLoader = new GLTFLoader(manager);
        gltfLoader.load("3D/fire/fire_emoji/scene.gltf", (gltf) => {
          var color = fire_colors[Math.floor(location.confidence / 25)];
		  var size = Math.floor(location.confidence / 25)
		  if(size==0) size = 1
          gltf.scene.traverse(function (node) {
            if (node.isMesh) {
              node.material = new THREE.MeshStandardMaterial({
                color: new THREE.Color(color),
                metalness: 0,
                roughness: 1,
              });
              node.castShadow = true;
              node.name = index;
            }
          });
          gltf.castShadow = true;
          gltf.scene.castShadow = true;
          const root = gltf.scene;
          root.receiveShadow = true;
          root.castShadow = true;
          root.eulerOrder = "ZXY";
          var pos = parent.angles2xyz(
            location.latitude + 1,
            parent.long2angles(location.longitude),
            distance_from_earth_core
          );
          root.position.set(pos[0], pos[1], pos[2]);
          let scale = 0.0005 * size;
          root.scale.set(scale, scale, scale);
          root.rotation.y = Math.PI;
          scene.add(root);
        });
      });
    };
    loadMarkers(this.scene);

    // Hemisphere Light
    var light = new THREE.HemisphereLight(0xffffbb, 0x080820, 0.25);
    this.scene.add(light);

    // Spot Light // SUN
    var spotLight = this.getSpotLight(0.85, "#fff9a8");
    geometry = new THREE.SphereGeometry(20, 20, 20);
    material = new THREE.MeshToonMaterial({
      emissive: "#ffd000",
      fog: false,
      side: THREE.DoubleSide,
    });
    var lightHelper = new THREE.Mesh(geometry, material);
    lightHelper.name = "sun";
    spotLight.add(lightHelper);
    this.scene.add(spotLight);

    // Spot Light / MOON
    var moonLight = this.getSpotLight(0.5, "#f0f");
    geometry = new THREE.SphereGeometry(10, 20, 20);
    material = new THREE.MeshToonMaterial({
      emissive: "#DDD",
      fog: false,
    });
    lightHelper = new THREE.Mesh(geometry, material);
    lightHelper.name = "moon";
    moonLight.add(lightHelper);
    this.scene.add(moonLight);

    // TWEEN Animations
    // this.camera
    var pos = this.angles2xyz(25, -5, 250);
    new TWEEN.Tween({
      x: 0,
      y: 0,
      z: 0,
    })
		.to({ x: pos[0], y: pos[1], z: pos[2] }, 4000)
		.onUpdate(function (val) {
			parent.camera.position.x = val.x;
			parent.camera.position.y = val.y;
			parent.camera.position.z = val.z;
		})
		.easing(TWEEN.Easing.Circular.Out)
		.repeat()
		.start()

    	// INTRO
		.onComplete(() => {
			document.getElementById('intro').style.display = 'flex';
		});

    // Spot Light // SUN
    pos = this.angles2xyz(0, -30, 500);
    new TWEEN.Tween({
      x: -300,
      y: 400,
      z: -100,
    })
      .to({ x: pos[0], y: pos[1], z: pos[2] }, 7000)
      .onUpdate(function (val) {
        spotLight.position.y = val.x;
        spotLight.position.x = val.y;
        spotLight.position.z = val.z;
      })
      // .delay(1000)
      .easing(TWEEN.Easing.Back.Out)
      .start();

    // Spot Light // MOON
    pos = this.angles2xyz(170, 9, 300);
    new TWEEN.Tween({
      x: 300,
      y: 400,
      z: -100,
    })
      .to({ x: pos[0], y: pos[1], z: pos[2] }, 7000)
      .onUpdate(function (val) {
        moonLight.position.y = val.x;
        moonLight.position.x = val.y;
        moonLight.position.z = val.z;
      })
      // .delay(1000)
      .easing(TWEEN.Easing.Back.Out)
      .start();

    var cameraZposition = new THREE.Group();
    var cameraXRotation = new THREE.Group();
    var cameraYRotation = new THREE.Group();

    cameraZposition.add(this.camera);
    cameraXRotation.add(cameraZposition);
    cameraYRotation.add(cameraXRotation);

    renderer.sortObjects = false;
    renderer.render(this.scene, cameraYRotation);

    renderer.setClearColor("#000005");

    var loadBalloon = function async(scene) {
      const gltfLoader = new GLTFLoader(manager);
      gltfLoader.load("3D/balloon/hot_air_balloon/scene.gltf", (gltf) => {
        gltf.scene.traverse(function (node) {
          if (node.isMesh) {
            let temp = node.material.color;
            node.name = "balloon";
            node.material = new THREE.MeshToonMaterial({
              color: temp,
              metalness: 0.5,
              roughness: 1,
              side: THREE.DoubleSide,
            });

            node.castShadow = true;
            node.receiveSh = true;
          }
        });
        gltf.castShadow = true;
        gltf.scene.castShadow = true;

        const root = gltf.scene;
        root.name = "balloon";
        root.receiveShadow = true;
        root.castShadow = true;
        root.eulerOrder = "ZXY";
        // var size = 0.02;
        root.rotation.x = Math.PI;

        let max = 2;
        let min = max * -1;
        let randX = Math.random() * (max - min) + min;
        let randY = Math.random() * (max - min) + min;
        let randZ = Math.random() * (max - min) + min;
        var pos = parent.angles2xyz(33, -5, 150);
        new TWEEN.Tween({
          x: 0,
          y: 0,
          z: 0,
          size: 0.5,
        })
          .to(
            {
              x: pos[0] + randX,
              y: pos[1] + randY,
              z: pos[2] + randZ,
              size: 2,
            },
            3000
          )
          .onUpdate(function (val) {
            root.position.x = val.x;
            root.position.y = val.y;
            root.position.z = val.z;
            root.scale.set(val.size, val.size, val.size);
            root.lookAt(0, 50, 0);
          })
          .easing(TWEEN.Easing.Circular.Out)
          .repeat()
          .start();

        new TWEEN.Tween({
          rot: 0,
        })
          .to({ rot: 5 * Math.PI }, 7000)
          .onUpdate(function (val) {
            root.rotation.y = val.rot;
          })
          .easing(TWEEN.Easing.Linear.None)
          .repeat()
          .start()
          .onComplete(() => {});
        scene.add(root);
      });
    };
    loadBalloon(this.scene);

    var loadTornado = function async(scene) {
      const gltfLoader = new GLTFLoader(manager);
      gltfLoader.load("3D/tornado/fire_tornado/scene.gltf", (gltf) => {
        gltf.scene.traverse(function (node) {
          if (node.isMesh) {
            let temp = node.material.color;
            node.name = "tornado";
            node.material = new THREE.MeshToonMaterial({
              color: temp,
              metalness: 0.5,
              roughness: 1,
              side: THREE.DoubleSide,
            });

            node.castShadow = true;
            node.receiveSh = true;
          }
        });
        gltf.castShadow = true;
        gltf.scene.castShadow = true;

        const root = gltf.scene;
        root.name = "tornado";
        root.receiveShadow = true;
        root.castShadow = true;
        root.eulerOrder = "ZXY";
        root.scale.set(0, 0, 0);
        // root.rotation.x = 3*Math.PI;
        // root.rotation.z = 3*Math.PI/2;

        var pos = parent.angles2xyz(33, -50, 100);
        new TWEEN.Tween({
          x: 0,
          y: 0,
          z: 0,
          size: 0.005,
        })
          .to({ x: pos[0], y: pos[1], z: pos[2], size: 0.01 }, 10000)
          .onUpdate(function (val) {
            root.position.x = val.x;
            root.position.y = val.y;
            root.position.z = val.z;
            root.scale.set(val.size, val.size, val.size);
            root.lookAt(0, 110, 0);
          })
          .easing(TWEEN.Easing.Exponential.In)
          .repeat()
          .start();

        new TWEEN.Tween({
          rot: 0,
        })
          .to({ rot: 15 * Math.PI }, 25000)
          .onUpdate(function (val) {
            root.rotation.y = val.rot;
          })
          .easing(TWEEN.Easing.Linear.None)
          .repeat()
          .start()
          .onComplete(() => {});
        scene.add(root);
      });
    };
    loadTornado(this.scene);

    var update = function (
      renderer,
      scene,
      camera,
      controls,
      raycaster,
      mouse
    ) {
      renderer.render(scene, camera);
      controls.update();

      TWEEN.update();

      var sky = scene.getObjectByName("sky");
      var tornado = scene.getObjectByName("tornado");

      if (sky) {
        sky.rotation.y -= 0.00025;
      }

      var balloon = scene.getObjectByName("balloon");
      if (balloon) {
        balloon.rotation.y += 0.007;
        tornado.rotation.y += 0.1;
      }

      requestAnimationFrame(function () {
        update(renderer, scene, camera, controls, raycaster, mouse);
      });
    };

    var controls = new OrbitControls(this.camera, renderer.domElement);
    controls.enablePan = false;
    controls.enableDamping = true;
    controls.dampingFactor = 0.075;
    controls.minDistance = 150;
    controls.maxDistance = 700;

    update(
      renderer,
      this.scene,
      this.camera,
      controls,
      this.raycaster,
      this.mouse
    );

    window.addEventListener(
      "mousemove",
      (event) =>
        this.onMouseMove(
          event,
          this.mouse,
          this.raycaster,
          this.camera,
          this.scene
        ),
      false
    );

    window.addEventListener(
      "click",
      (event) =>
        this.mouseClick(this.scene, this.raycaster, this.mouse, this.camera),
      false
    );
  }

  getPointLight() {
    var light = new THREE.PointLight("#FFF", 0.1);
    light.position.set(1, 2, 1);
    light.castShadow = true;
    light.shadow.bias = 0.001;
    light.shadow.mapSize = 2048 * 2;
    return light;
  }

  getSpotLight(intensity, color) {
    var light = new THREE.SpotLight(color, intensity);
    light.position.set(1, 2, 1);
    light.castShadow = true;
    light.shadow.bias = 0.001;
    light.penumbra = 1;
    light.angle = 1;
    light.decay = 1;
    light.distance = 4000;
    light.shadow.mapSize.width = 2048 * 4;
    light.shadow.mapSize.height = 2048 * 4;
    light.shadow.camera.near = 5;
    light.shadow.camera.far = 1000;
    return light;
  }

  render() {
    return (
      <>
        <Loading />
        <Modal />
        <Intro />
        <About />
        <Tooltip />

        {/* {this.target && <Rates target={this.target}/>} */}

        {/* <Leaderboard leader="hh" /> */}
      </>
    );
  }
}

export default AA;
